export type TVariant = 'text' | 'component';
export type TSize = 'XXS' | 'XS' | 'S' | 'M' | 'L' | 'XL' | 'XXL';

const SIZES = {
  component: { XXS: 8, XS: 12, S: 16, M: 24, L: 40, XL: 64, XXL: 80 },
  text: { XXS: 12, XS: 16, S: 20, M: 24, L: 28, XL: 36, XXL: 64 },
} as const;

export default SIZES;
